module.exports = __webpack_public_path__ + "static/media/money-bill.5cdcce5b.svg";